import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchProductDetailsAPI } from "./productDetailsAPI";

export const fetchProductDetailsData = createAsyncThunk(
    "product/fetchProductDetailsData",
    async (id) => {
        const data = await fetchProductDetailsAPI(id);
        return data
    }
)

const productDetailsSlice = createSlice({
    name: "productData",
    initialState: {
        product_details: {},
        loading: false,
        error: null
    },

    reducers: {},

    extraReducers: (builder) => {
        builder
        .addCase(fetchProductDetailsData.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchProductDetailsData.fulfilled, (state, action) => {
            state.loading = false;
            state.product_details = action.payload.data || {};
        })
        .addCase(fetchProductDetailsData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        })
    }
})

export default productDetailsSlice.reducer;